export function StatusBadge({ status }: { status: "online" | "offline" }) {
  const isOnline = status === "online";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${
        isOnline
          ? "bg-emerald-500/10 text-emerald-400"
          : "bg-rose-500/10 text-rose-400"
      }`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${isOnline ? "bg-emerald-400" : "bg-rose-400"} ${
          isOnline ? "animate-pulse-soft" : ""
        }`}
      />
      {isOnline ? "Online" : "Offline"}
    </span>
  );
}
